import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicyPage = () => {
  return (
    <div className="page">
      <section className="hero" style={{minHeight: '50vh', paddingTop: 'calc(80px + var(--spacing-xl))'}}>
        <div className="container hero-content">
          <span className="section-label">Legal</span>
          <h1>Cookie Policy</h1>
          <p>Last updated: December 29, 2025</p>
        </div>
      </section>

      <section className="section">
        <div className="container" style={{ maxWidth: '900px' }}>
          <div className="card" style={{ padding: 'var(--spacing-xl)' }}>
            
            <h2>1. What Are Cookies?</h2>
            <p>
              Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.
            </p>

            <h2>2. How We Use Cookies</h2>
            <p>
              SEVENHC uses cookies to:
            </p>
            <ul>
              <li>Ensure our website functions properly</li>
              <li>Remember your preferences and settings</li>
              <li>Analyze how visitors use our website</li>
              <li>Improve your experience on our site</li>
              <li>Deliver personalized content (with your consent)</li>
            </ul>

            <h2>3. Types of Cookies We Use</h2>

            <h3>3.1 Strictly Necessary Cookies</h3>
            <div className="card" style={{background: 'var(--color-black)', padding: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)'}}>
              <p><strong>Purpose:</strong> Essential for the website to function</p>
              <p><strong>Consent Required:</strong> No (these are essential)</p>
              <p><strong>Examples:</strong></p>
              <ul>
                <li><code>sevenhc_session</code> - Session management</li>
                <li><code>sevenhc_cookie_consent</code> - Stores your cookie preferences</li>
                <li><code>csrf_token</code> - Security protection</li>
              </ul>
              <p><strong>Retention:</strong> Session or up to 1 year</p>
            </div>

            <h3>3.2 Functional Cookies</h3>
            <div className="card" style={{background: 'var(--color-black)', padding: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)'}}>
              <p><strong>Purpose:</strong> Remember your preferences and settings</p>
              <p><strong>Consent Required:</strong> Yes</p>
              <p><strong>Examples:</strong></p>
              <ul>
                <li><code>language_preference</code> - Stores your language choice</li>
                <li><code>ui_settings</code> - Remembers UI customizations</li>
              </ul>
              <p><strong>Retention:</strong> Up to 1 year</p>
            </div>

            <h3>3.3 Analytics & Performance Cookies</h3>
            <div className="card" style={{background: 'var(--color-black)', padding: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)'}}>
              <p><strong>Purpose:</strong> Help us understand how visitors use our website</p>
              <p><strong>Consent Required:</strong> Yes (GDPR/CCPA compliance)</p>
              <p><strong>Third-Party Services:</strong></p>
              <ul>
                <li>
                  <strong>Google Analytics 4 (GA4)</strong>
                  <ul>
                    <li><code>_ga</code> - Distinguishes unique users</li>
                    <li><code>_ga_*</code> - Maintains session state</li>
                    <li><code>_gid</code> - Distinguishes users for 24 hours</li>
                  </ul>
                  <p>Google Analytics is configured with IP anonymization and operates in consent mode.</p>
                  <p><strong>Privacy Policy:</strong> <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></p>
                </li>
              </ul>
              <p><strong>Retention:</strong> Up to 2 years</p>
            </div>

            <h3>3.4 Marketing & Advertising Cookies</h3>
            <div className="card" style={{background: 'var(--color-black)', padding: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)'}}>
              <p><strong>Purpose:</strong> Deliver personalized advertisements</p>
              <p><strong>Consent Required:</strong> Yes</p>
              <p><strong>Status:</strong> Currently not in use. If we implement marketing cookies in the future, we will update this policy and request your consent.</p>
              <p><strong>Retention:</strong> Up to 1 year (when implemented)</p>
            </div>

            <h2>4. Your Cookie Choices</h2>
            <p>
              You have the right to choose whether or not to accept cookies. When you first visit our website, you can:
            </p>
            <ul>
              <li><strong>Accept All:</strong> Consent to all cookie categories</li>
              <li><strong>Reject All:</strong> Only strictly necessary cookies will be used</li>
              <li><strong>Customize:</strong> Choose specific cookie categories</li>
            </ul>

            <div className="card" style={{background: 'var(--color-blue-darker)', padding: 'var(--spacing-md)', marginTop: 'var(--spacing-md)', marginBottom: 'var(--spacing-md)'}}>
              <p style={{margin: 0}}>
                <strong>Want to change your preferences?</strong> You can update your cookie settings at any time by clicking <button 
                  onClick={() => window.dispatchEvent(new Event('openCookiePreferences'))}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--color-blue-light)',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    padding: 0,
                    font: 'inherit'
                  }}
                >
                  Cookie Settings
                </button> in our footer or here.
              </p>
            </div>

            <h2>5. Browser Controls</h2>
            <p>
              Most web browsers allow you to control cookies through their settings. However, if you block all cookies, some parts of our website may not function properly.
            </p>
            <p><strong>How to manage cookies in popular browsers:</strong></p>
            <ul>
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
              <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
            </ul>

            <h2>6. Third-Party Cookies</h2>
            <p>
              Some cookies on our website are set by third-party services. We only use trusted third-party services and ensure they comply with relevant data protection regulations.
            </p>

            <h2>7. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time. When we make significant changes, we will notify you by updating the "Last updated" date at the top of this page and may request your consent again if required by law.
            </p>

            <h2>8. Your Rights (GDPR & CCPA)</h2>
            <p>
              Under GDPR (European Union) and CCPA (California), you have specific rights regarding your data:
            </p>
            <ul>
              <li><strong>Right to Access:</strong> Know what data we collect</li>
              <li><strong>Right to Delete:</strong> Request deletion of your data</li>
              <li><strong>Right to Object:</strong> Object to data processing</li>
              <li><strong>Right to Withdraw Consent:</strong> Change cookie preferences anytime</li>
              <li><strong>Right to Data Portability:</strong> Receive your data in a portable format</li>
            </ul>

            <h2>9. Contact Us</h2>
            <p>
              If you have questions about our use of cookies or this Cookie Policy, please contact us:
            </p>
            <div className="card" style={{background: 'var(--color-black)', padding: 'var(--spacing-md)', marginTop: 'var(--spacing-md)'}}>
              <p><strong>Email:</strong> <a href="mailto:privacy@sevenhc.net">privacy@sevenhc.net</a></p>
              <p><strong>Phone:</strong> +94 77 23 53 975</p>
              <p style={{margin: 0}}><strong>Address:</strong> SEVENHC, Sri Lanka</p>
            </div>

            <div style={{ marginTop: 'var(--spacing-xl)', paddingTop: 'var(--spacing-lg)', borderTop: '1px solid var(--color-black-lighter)', display: 'flex', gap: 'var(--spacing-md)', flexWrap: 'wrap' }}>
              <Link to="/privacy" className="btn btn-secondary">Privacy Policy</Link>
              <Link to="/terms" className="btn btn-secondary">Terms of Service</Link>
              <Link to="/contact" className="btn btn-primary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
